import { React, useState, useEffect } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import SongListCriteriaItem from './SongListCriteriaItem';
import { useDrop } from 'react-dnd';

export default function SongListCriteriaList(props) {

    const [ items, setItems ] = useState({});

    useEffect(() => {
        // console.log(`SongListCriteriaList.useEffect(): ${props.itemGroup} ${props.criteriaType} items: ${Object.keys(props.items).length} itemCount: ${props.itemCount}`);
        setItems(props.items);
    }, [props.items, props.itemCount])

    const moveItem = ((item, monitor) => {
         // console.log(`SongListCriteriaList.moveItem(${JSON.stringify({'itemId': item.itemId, 'item_itemGroup': item.itemGroup, 'props_itemGroup': props.itemGroup})})`);
         props.itemMover(item, item.itemGroup, props.itemGroup);
    });

    const [{dragItem, isOver}, drop] = useDrop(() => ({
        accept: props.criteriaType,
        drop: (itm, mon) => moveItem(itm, mon),
        collect: (monitor) => ({
            dragItem: monitor.getItem(),
            isOver: !!monitor.isOver()
        })
    }),
    [props.items, props.itemCount]
    )


// console.log(`SongListCriteriaList() ${props.itemGroup} ${props.criteriaType} item count: ${JSON.stringify(props.itemCount)}`)
return(
<Card.Body ref={drop} className="border" 
        style={{ 'overflow-y': 'auto' }} >
    <ListGroup>
    {Object.values(items).map((item) => (
        <SongListCriteriaItem id={item.itemId} 
                            criteriaType={props.criteriaType} 
                            item={item} 
                            itemCount={props.itemCount}/>
    ))}
    </ListGroup>
</Card.Body>
)
}